import { action, computed, observable, makeObservable } from 'mobx';
import Configuracao from '../utils/Configuracao';
import EscaninhoStore from './EscaninhoStore';
import FiltroStore from './FiltroStore';

class PaginacaoStore {
    // @observable totalRegistros: number = 0;
    paginaEscaninhoCompleto: number = 1;
    paginaFiltro: number = 1;
    tamanhoPaginaSessao: number = Configuracao.TAMANHO_PAGINA;

    constructor() {
        makeObservable(this, {
            paginaEscaninhoCompleto: observable,
            paginaFiltro: observable,
            tamanhoPaginaSessao: observable,
            primeiroIndice: computed,
            ultimoIndice: computed,
            totalRegistros: computed,
            pagina: computed,
            registroInicial: computed,
            registroFinal: computed,
            mudarTamanhoPagina: action,
            handleTrocaPagina: action
        });
    }

    get primeiroIndice() {
        return (this.pagina - 1) * this.tamanhoPaginaSessao;
    }
    get ultimoIndice() {
        return this.pagina * this.tamanhoPaginaSessao;
    }

    get totalRegistros() {
        if (EscaninhoStore.tipoEscaninho === 'gerencial' && FiltroStore.processosPreparados !== undefined) {
            return FiltroStore.processosPreparados.length;
        }
        return EscaninhoStore.processosPorTipoEscaninho.filter(proc => proc.mostrar).length;
    }

    get qtdProcessos() {
        return this.totalRegistros;
    }

    get qtdPaginas() {
        return this.qtdProcessos <= this.tamanhoPaginaSessao ? 1 : Math.ceil(this.qtdProcessos / this.tamanhoPaginaSessao);
    }

    get pagina() {
        if (FiltroStore.filtroAplicado) {
            return this.paginaFiltro;
        } else {
            return this.paginaEscaninhoCompleto;
        }
    }
    get registroInicial() {
        return (this.pagina - 1) * this.tamanhoPaginaSessao + 1;
    }
    get registroFinal() {
        return this.pagina === this.qtdPaginas ? this.qtdProcessos : this.pagina * this.tamanhoPaginaSessao;
    }
    mudarTamanhoPagina = (novoTamanhoPagina) => {
        const novaPagina = this.registroInicial ? Math.ceil(this.registroInicial / novoTamanhoPagina) : 0;
        this.tamanhoPaginaSessao = novoTamanhoPagina;
        this.handleTrocaPagina(novaPagina);
    };
    handleTrocaPagina = (novaPagina) => {

        if (novaPagina <= 0) {
            novaPagina = 1;
        } else if (novaPagina > this.qtdPaginas) {
            novaPagina = this.qtdPaginas;
        }

        if (FiltroStore.filtroAplicado) {
            this.paginaFiltro = novaPagina;
        } else {
            this.paginaEscaninhoCompleto = novaPagina;
        }
    };

    handlePaginaAnterior = () => {
        this.handleTrocaPagina(this.pagina - 1);
    }

    handleProximaPagina = () => {
        this.handleTrocaPagina(this.pagina + 1);
    }
}

export default new PaginacaoStore();
